var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vimeo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.206,
    height: 57.205,
    viewBox: "0 0 57.206 57.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M28.6,0a28.6,28.6,0,1,0,28.6,28.6A28.6,28.6,0,0,0,28.6,0Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M8.24,18.515s2.719-2.143,3.625-1.073,4.366,14.008,5.52,16.395c1.008,2.093,3.788,4.859,6.836,2.883s13.181-10.628,15-20.844S27.023,7.8,25.54,16.7c3.709-2.226,5.688.9,3.79,4.449S25.7,27,24.8,27s-1.6-2.37-2.637-6.512c-1.071-4.281-1.065-12-5.519-11.121-4.2.824-9.721,7.417-9.721,7.417l1.319,1.73Z",
    transform: "translate(5.451 7.15)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.c6b5ba6b2d793c564714f05f6a82fbe2.svg";
export { ForwardRef as ReactComponent };